const actions = {
  CREATE_JOB_BEGIN: 'CREATE_JOB_BEGIN',
  CREATE_JOB_SUCCESS: 'CREATE_JOB_SUCCESS',
  CREATE_JOB_ERR: 'CREATE_JOB_ERR',

  JOBS_READ_BEGIN: 'JOBS_READ_BEGIN',
  JOBS_READ_SUCCESS: 'JOBS_READ_SUCCESS',
  JOBS_READ_ERR: 'JOBS_READ_ERR',
  JOBS_READ_LENGTH: 'JOBS_READ_LENGTH',

  GET_JOB_BEGIN: 'GET_JOB_BEGIN',
  GET_JOB_SUCCESS: 'GET_JOB_SUCCESS',
  GET_JOB_ERR: 'GET_JOB_ERR',

  JOBS_STATS_BEGIN: 'JOBS_STATS_BEGIN',
  JOBS_STATS_SUCCESS: 'JOBS_STATS_SUCCESS',
  JOBS_STATS_ERR: 'JOBS_STATS_ERR',

  GET_FILTERS_BEGIN: 'GET_FILTERS_BEGIN',
  GET_FILTERS_SUCCESS: 'GET_FILTERS_SUCCESS',
  GET_FILTERS_ERR: 'GET_FILTERS_ERR',

  CANCEL_JOB_BEGIN: 'CANCEL_JOB_BEGIN',
  CANCEL_JOB_SUCCESS: 'CANCEL_JOB_SUCCESS',
  CANCEL_JOB_ERR: 'CANCEL_JOB_ERR',

  DELETE_JOB_BEGIN: 'DELETE_JOB_BEGIN',
  DELETE_JOB_SUCCESS: 'DELETE_JOB_SUCCESS',
  DELETE_JOB_ERR: 'DELETE_JOB_ERR',

  UPDATE_JOB_FILTER: 'UPDATE_JOB_FILTER',

  createJobBegin: () => {
    return {
      type: actions.CREATE_JOB_BEGIN,
    };
  },

  createJobSuccess: (data) => {
    return {
      type: actions.CREATE_JOB_SUCCESS,
      data,
    };
  },

  createJobErr: (err) => {
    return {
      type: actions.CREATE_JOB_ERR,
      err,
    };
  },

  jobsStatsBegin: () => {
    return {
      type: actions.JOBS_STATS_BEGIN,
    };
  },

  jobsStatsSuccess: (data) => {
    return {
      type: actions.JOBS_STATS_SUCCESS,
      data,
    };
  },

  jobsStatsErr: (err) => {
    return {
      type: actions.JOBS_STATS_ERR,
      err,
    };
  },

  getFiltersBegin: () => {
    return {
      type: actions.GET_FILTERS_BEGIN,
    };
  },

  getFiltersSuccess: (data) => {
    return {
      type: actions.GET_FILTERS_SUCCESS,
      data,
    };
  },

  getFiltersErr: (err) => {
    return {
      type: actions.GET_FILTERS_ERR,
      err,
    };
  },

  jobsReadBegin: () => {
    return {
      type: actions.JOBS_READ_BEGIN,
    };
  },

  jobsReadSuccess: (data) => {
    return {
      type: actions.JOBS_READ_SUCCESS,
      data,
    };
  },

  jobsReadErr: (err) => {
    return {
      type: actions.JOBS_READ_ERR,
      err,
    };
  },

  jobsReadLength: (data) => {
    return {
      type: actions.JOBS_READ_LENGTH,
      data,
    };
  },

  getJobBegin: () => {
    return {
      type: actions.GET_JOB_BEGIN,
    };
  },

  getJobSuccess: (data) => {
    return {
      type: actions.GET_JOB_SUCCESS,
      data,
    };
  },

  getJobErr: (err) => {
    return {
      type: actions.GET_JOB_ERR,
      err,
    };
  },

  cancelJobBegin: () => {
    return {
      type: actions.CANCEL_JOB_BEGIN,
    };
  },

  cancelJobSuccess: (data) => {
    return {
      type: actions.CANCEL_JOB_SUCCESS,
      data,
    };
  },

  cancelJobErr: (err) => {
    return {
      type: actions.CANCEL_JOB_ERR,
      err,
    };
  },

  deleteJobBegin: () => {
    return {
      type: actions.DELETE_JOB_BEGIN,
    };
  },

  deleteJobSuccess: (data) => {
    return {
      type: actions.DELETE_JOB_SUCCESS,
      data,
    };
  },

  deleteJobErr: (err) => {
    return {
      type: actions.DELETE_JOB_ERR,
      err,
    };
  },

  updateJobFilterAction: (data) => {
    return {
      type: actions.UPDATE_JOB_FILTER,
      data,
    };
  },
};

export default actions;
